import React, { Component, Fragment } from "react";
import SaveAs from "./SaveAs/SaveAs";
import "./BottomControl.scss";
import cloneDeep from "lodash.clonedeep";
import Mobile from "../../assets/images/mobile.svg";
import * as UTILS from "../../utils/Utils";
import * as actionTypes from "../../store/Actions/actions";
import { connect } from "react-redux";
import expandICON from "../../assets/images/expand.svg";
import restoreICON from "../../assets/images/restore.svg";
import preview from "../../assets/images/preview2.svg";
import save from "../../assets/images/save.svg";
import { track } from "@amplitude/analytics-browser";
import Axios from "../../axios";
class Control extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullScreen: false,
      saveEnabled: false,
      blockHeight: null,
      selectedCategory: null,
      activeBlock: false,
      blockSaved: false,
      blockLoader: false,
      categorySelected: false,
      animateModal: false,
      templateLoader: false,
      templateSaved: false,
      saveAsTemplate: false,
      clickedSave: false,
      errorInSave: false,
      saved: false,
      snapshot: false,
    };
    this.clickedSave = this.clickedSave.bind(this);
    this.getHeightOfElements = this.getHeightOfElements.bind(this);
    // this.keyPressed = this.keyPressed.bind(this);
  }
  componentDidMount() {
    document.addEventListener(
      "fullscreenchange",
      () => {
        if (
          !document.fullscreenElement && // alternative standard method
          !document.mozFullScreenElement &&
          !document.webkitFullscreenElement &&
          !document.msFullscreenElement
        ) {
          this.setState({
            ...this.state,
            fullScreen: false,
          });
        } else {
          this.setState({
            ...this.state,
            fullScreen: true,
          });
        }
      },
      false
    );
  }
  componentWillUnmount() {
    // document.removeEventListener("keydown", this.keyPressed, false);
  }
  toggleFullscreen = () => {
    if (
      !document.fullscreenElement && // alternative standard method
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };
  clickedSave = () => {

    this.props.setTool('SaveAs')
    track('Navigation Item',
      {
        menuItem: 'Save',
        deviceView: this.props.mobileActive ? 'Mobile' : 'Desktop'
      });
    this.setState(
      {
        saveEnabled: !this.state.saveEnabled,
        activeBlock: false,
      },

    );
  };
  keyPressed(event, func) {
    event.preventDefault();
    if (event.ctrlKey && event.key === "z") {
      func();
    }
    if (event.ctrlKey && event.key === "y") {
      func();
    }
  }

  getHeightOfElements = () => {
    var divs = document.querySelector(".getHeightWrapper").offsetHeight;
    var self = this;

    var blockHeight = null;

    self.setState({
      blockHeight: divs,
    });
  };
  saveTemplate = () => {
    const blockHeight = JSON.stringify(this.state.blockHeight);
    let layout = cloneDeep(this.props.layout);
    
    let blockDataToPush = { ...this.props.storeDATA, layout: layout };

    const newLayout = JSON.stringify(blockDataToPush);
    this.setState({
      templateLoader: true,
    });
    const self = this;
    let data = {
      u: this.props.userID,
      sn: this.props.sessionID,
      td: newLayout,
      t: "T",
      o: "1", // 2 for default 1 for custom
      h: blockHeight,
      d: "N", // Y for default N for custom
      c: "custom", // default_template & custom
    };

    if (data) {
      Axios.TemplateService.POST_TEMPLATE(data).then((response) => {
        if (response.status == "200") {
          self.setState(
            {
              templateSaved: true,
              templateLoader: false,
            },
            () => {
              setTimeout(
                function () {
                  self.setState({
                    saveEnabled: false,
                    templateSaved: false,
                  });
                }.bind(this),
                3000
              );
            }
          );
        }
        if (response.status == "error") {
        }
      });
      // .catch(error => {

      // });
    }
  };
  saveAsMultimedia = () => {
    this.props.postData();
    if (!this.props.clickedSave) {
      setTimeout(() => {
        this.setState(
          {
            saved: false,
          },
          () => {
            // this.setState({
            //   saveEnabled: false
            // });
          }
        );
      }, 3000);
    }
  };
  postDataForPreview = () => {
    track("Navigation Item", {
      menuItem: "Preview",
      deviceView: this.props.mobileView ? "Mobile" : "Desktop",
    });
    let layout = cloneDeep(this.props.layout);
    let layoutList = cloneDeep(this.props.layoutList);
   layoutList = layoutList.map((item) => {
      return item[0] == this.props.layoutTitle
        ? [this.props.layoutTitle, layout]
        : item;
    });
    let payLoad = JSON.stringify({
      ...this.props.storeDATA,
      layoutList: layoutList,
    });
    let data = {
      fd: payLoad,
      f: this.props.flimpID,
      u: this.props.userID,
      sn: this.props.sessionID,
    };
    this.setState(
      {
        clickedSave: true,
        errorInSave: false,
        nothingToSave: true,
      },
      () => {
        setTimeout(
          function () {
            this.setState({
              nothingToSave: false,
            });
          }.bind(this),
          3000
        );
      }
    );

    Axios.MicrositeService.POST_MICROSITE(data)
      .then((response) => {
        if (response.data.statusCode === "success") {
          this.setState(
            {
              saved: true,
            },
            () => {
              const preview = this.props.preview;

              window.open(
                import.meta.env.VITE_PREVIEW_URL + this.props.short_code,
                "_blank"
              );
              setTimeout(
                function () {
                  this.setState({ saved: false, clickedSave: false });
                }.bind(this),
                3000
              );
            }
          );
        }
        if (response.data.statusCode !== "success") {
          this.setState({
            errorInSave: true,
            saved: false,
            clickedSave: false,
          });
        }
        if (response.data.statusCode == "401") {
          window.location =
            location.protocol + "//" + location.hostname + "/login";
        }
      })
      .catch((error) => {
        this.setState({
          errorInSave: true,
          saved: false,
          clickedSave: false,
        });
      });
  };
  render() {
    return (
      <Fragment>
        {this.props.tool == 'SaveAs' && (
          <SaveAs
            saveReloadAgain={this.props.saveReloadAgain}
            snapshotApiError={this.props.snapshotApiError}
            creatingSnapshot={this.props.creatingSnapshot}
            saveAsTemplate={this.state.saveAsTemplate}
            TemplateSelected={this.props.TemplateSelected}
            activeBlock={this.state.activeBlock}
            saveTemplate={this.saveTemplate}
            templateLoader={this.state.templateLoader}
            templateSaved={this.state.templateSaved}
            errorInSave={this.props.errorInSave}
            layoutLength={this.props.layoutLength}
            blockLoader={this.state.blockLoader}
            blockSaved={this.state.blockSaved}
            selectedCategory={(e) => {
              const selectedCategory = e.hasOwnProperty("target")
                ? e.target.value !== "Select Category"
                  ? true
                  : false
                : true;
              const categoryValue = e.hasOwnProperty("target")
                ? e.target.value !== "Select Category"
                  ? e.target.value
                  : null
                : "custom";
              this.props.categorySelectedValue(categoryValue);
              this.props.categorySelectedState(selectedCategory);
              let category = e.hasOwnProperty("target") ? e.target.value : e;
              this.setState(
                {
                  selectedCategory: category,
                },
                () => {
                  this.props.categorySelected
                    ? this.props.blockActivated(true)
                    : this.props.blockActivated(false);
                  const animateModal = this.props.categorySelected
                    ? true
                    : false;
                  this.props.animateModalState(animateModal);

                  setTimeout(
                    function () {
                      this.setState({
                        saveEnabled: selectedCategory && false,
                        activeBlock: selectedCategory && false,
                      });
                    }.bind(this),
                    500
                  );
                }
              );
            }}
            blockActive={() => {
              this.setState({
                activeBlock: true,
              });
            }}
            saved={this.props.saved}
            clickedSave={this.props.clickedSave}
            saveAsMultimedia={this.saveAsMultimedia}
            close={() => {
           this.props.setTool(null)
            }}
          />
        )}
        <div className="control-wrapper ">
          {/* <ul>
            <li>
              <button onClick={this.props.ClearAll} className="delete">
                Clear Canvas
              </button>
            </li>
          </ul> */}
          <div
            onClick={() => {
              this.postDataForPreview();
            }}
            className={
              "tool-bar-button" +
              (this.state.clickedSave || this.state.saved ? " saving" : " ")
              + " sixth-step"
            }
          >
            {this.state.clickedSave ? (
              ""
            ) : (
              <img className="preview" src={preview}></img>
            )}
            <span>Preview</span>
            {this.state.clickedSave ? <div className="loading"></div> : ""}
          </div>
          <div
            onClick={this.clickedSave}
            className="saveAsWrap tool-bar-button seventh-step"
          >
            <img src={save}></img>
            <span>Save</span>
          </div>
          <div
            className={"tool-bar-button expand eighth-step "}
            onClick={() => {
              track("Navigation Item", {
                menuItem: "Expand",
                deviceView: this.props.mobileActive ? "Mobile" : "Desktop",
              });
              if (
                !document.fullscreenElement && // alternative standard method
                !document.mozFullScreenElement &&
                !document.webkitFullscreenElement &&
                !document.msFullscreenElement
              ) {
                this.setState({
                  fullScreen: true,
                });
                // current working methods
                if (document.documentElement.requestFullscreen) {
                  document.documentElement.requestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) {
                  document.documentElement.msRequestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                  document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                  document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                  );
                }
              } else {
                this.setState({
                  fullScreen: false,
                });
                if (document.exitFullscreen) {
                  document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
                }
              }
                  track("Navigation Item", {
                    menuItem: "Expand",
                    deviceView: this.props.mobileActive ? "Mobile" : "Desktop",
                  });
            }}
          >
            <img src={this.state.fullScreen ? restoreICON : expandICON}></img>
            <span>{this.state.fullScreen ? "Restore" : "Expand"}</span>
          </div>
          {/* <div
            className="show-add-tool mylibrary"
            onClick={this.props.showAddElementToggle}
          >
            <span>Toggle Add Element Tool</span>
          </div> */}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    storeDATA: state.present,
    layout: state.present.layout,
    layoutList: state.present.layoutList,
    layoutTitle: state.present.layoutTitle,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Control);
